var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webhook-config" },
    [
      _c("div", { staticClass: "config-field" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.webhookUrl")))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-with-variables" },
          [
            _c("a-input", {
              attrs: {
                placeholder: _vm.$t("taskModuleRules.webhookUrlExample"),
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.url,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "url", $$v)
                },
                expression: "localConfig.url",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.showVariablesPicker = true
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("taskModuleRules.variables")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("taskModuleRules.youCanUseDynamicVariablesInUrl")) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.httpMethod")))]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.method,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "method", $$v)
                },
                expression: "localConfig.method",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "GET" } }, [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.httpMethodGet"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "POST" } }, [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.httpMethodPost"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "PUT" } }, [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.httpMethodPut"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.localConfig.method !== "GET"
        ? _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.bodyType")))]),
              _vm._v(" "),
              _c(
                "a-radio-group",
                {
                  attrs: { "button-style": "solid" },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.bodyType,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "bodyType", $$v)
                    },
                    expression: "localConfig.bodyType",
                  },
                },
                [
                  _c("a-radio-button", { attrs: { value: "full_task" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.fullTaskData"))),
                  ]),
                  _vm._v(" "),
                  _c("a-radio-button", { attrs: { value: "custom" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.customJson"))),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.localConfig.method !== "GET" && _vm.localConfig.bodyType === "custom"
        ? _c("div", { staticClass: "config-field" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("taskModuleRules.customJsonBody"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-with-variables" },
              [
                _c("a-textarea", {
                  attrs: {
                    placeholder: _vm.$t(
                      "taskModuleRules.customJsonBodyExample"
                    ),
                    rows: 6,
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.customBody,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "customBody", $$v)
                    },
                    expression: "localConfig.customBody",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "link", size: "small" },
                    on: {
                      click: function ($event) {
                        _vm.showVariablesPicker = true
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("code"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("taskModuleRules.variables")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("small", [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t("taskModuleRules.enterValidJsonWithDynamicVariables")
                  ) +
                  "\n        "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("taskModuleRules.headersOptional"))),
          ]),
          _vm._v(" "),
          _vm._l(_vm.localConfig.headers, function (value, key, index) {
            return _c(
              "div",
              { key: "header-" + index, staticClass: "header-row" },
              [
                _c("a-input", {
                  staticStyle: { flex: "1" },
                  attrs: {
                    value: key,
                    placeholder: _vm.$t("taskModuleRules.headerName"),
                  },
                  on: {
                    change: function (e) {
                      return _vm.updateHeaderKey(key, e.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _c("a-input", {
                  staticStyle: { flex: "1" },
                  attrs: { placeholder: _vm.$t("taskModuleRules.headerValue") },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.headers[key],
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig.headers, key, $$v)
                    },
                    expression: "localConfig.headers[key]",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { type: "text", size: "small", danger: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeHeader(key)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "dashed", block: "" },
              on: { click: _vm.addHeader },
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("taskModuleRules.addHeader")) +
                  "\n        "
              ),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.showVariablesPicker
        ? _c("DynamicVariablesPicker", {
            attrs: { visible: _vm.showVariablesPicker },
            on: {
              close: function ($event) {
                _vm.showVariablesPicker = false
              },
              select: _vm.insertVariable,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }